import classNames from 'classnames'

import SvgIcon from '../SvgIcon/SvgIcon'

import styles from './ExpandableItemArrow.css'

type Props = {
  className?: string
  expanded?: boolean
}

function ExpandableItemArrow({className, expanded}: Props) {
  return (
    <SvgIcon
      className={classNames(className, styles.arrow, {[styles.visible]: expanded})}
      icon={expanded === true ? 'chevron-up' : 'chevron-down'}
    />
  )
}
ExpandableItemArrow.displayName = 'ExpandableItemArrow'
export default ExpandableItemArrow
